// Store writer — incremental update operations (ARCHITECTURE.md §12.5).
//
// These free functions operate on a StoreHandle and delegate to backend row
// operations. Each write runs inside a backend transaction for atomicity (§12.5).

import type { StoreHandle } from "./types.js";

/**
 * Insert or replace a file row. Replacement removes the previous file row.
 * Returns the new file id.
 */
export function upsertFile(
  db: StoreHandle,
  filePath: string,
  hash: string,
  language: string,
  lineCount: number,
  analyzerId: string,
): number {
  return db.backend.transaction(() =>
    db.backend.insertOrReplaceFile({
      path: filePath,
      hash,
      language,
      line_count: lineCount,
      analyzer_id: analyzerId,
      analyzed_at: new Date().toISOString(),
    }),
  );
}

/** Delete a file row. Returns true if removed. */
export function deleteFile(db: StoreHandle, filePath: string): boolean {
  return db.backend.transaction(() => db.backend.deleteFileByPath(filePath));
}

/** Upsert a metadata key/value pair (invalidation hashes, timestamps). */
export function upsertMetadata(
  db: StoreHandle,
  key: string,
  value: string,
): void {
  db.backend.setMetadata(key, value);
}
